import { supabaseClient } from "supabase/supabase";

export const queryUserByID = async ({ uid }: { uid: string }) => {
  const query = supabaseClient.from("users").select("*").eq("uid", uid);

  const { data, error } = await query;
  if (error) {
    throw error;
  }
  return data![0];
};
